module.exports = __webpack_public_path__ + "static/media/rest_passport.3db6dde2.png";